// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__xS5zR","label":"index_label__2ZAid","margin":"index_margin__23Clw","item":"index_item__ie38M"};